// Card color swatches: hovering a color dot swaps the card's primary image
// to that variant's photo, and suppresses the secondary-image hover overlay
// while previewing. Restores on mouse-out.
(function () {
  function primaryImg(card) {
    var media = card && card.querySelector('.card__media .media');
    if (!media) return null;
    return { media: media, img: media.querySelector('img') };
  }

  function onOver(e) {
    var dot = e.target.closest && e.target.closest('.card-swatch[data-media]');
    if (!dot) return;
    var card = dot.closest('.card-wrapper');
    var ref = primaryImg(card);
    if (!ref || !ref.img) return;
    if (!ref.img.dataset.originalSrc) {
      ref.img.dataset.originalSrc = ref.img.getAttribute('src') || '';
      ref.img.dataset.originalSrcset = ref.img.getAttribute('srcset') || '';
    }
    ref.img.setAttribute('srcset', '');
    ref.img.setAttribute('src', dot.getAttribute('data-media'));
    ref.media.classList.add('swatch-previewing');
  }

  function onOut(e) {
    var dot = e.target.closest && e.target.closest('.card-swatch[data-media]');
    if (!dot) return;
    var card = dot.closest('.card-wrapper');
    var ref = primaryImg(card);
    if (!ref || !ref.img) return;
    if (ref.img.dataset.originalSrc) {
      ref.img.setAttribute('src', ref.img.dataset.originalSrc);
      ref.img.setAttribute('srcset', ref.img.dataset.originalSrcset);
    }
    ref.media.classList.remove('swatch-previewing');
  }

  document.addEventListener('mouseover', onOver);
  document.addEventListener('mouseout', onOut);
})();
